const root = 'StoreSocialMediaForm'

export const TestId = {
  root,
  cardHeader: `${root}-cardHeader`,
  facebook: `${root}-facebook`,
  instagram: `${root}-instagram`,
  website: `${root}-website`,
  submitButton: `${root}-submitButton`,
  discardButton: `${root}-discardButton`,
}
